/**
 * Canonical viewport breakpoints.
 *
 * Single source of truth — every responsive rule in the app goes through
 * `useBreakpoint()` or `atLeast()`. Never re-derive from
 * `useWindowDimensions()` in a screen.
 *
 * The four-tier scale matches the dominant desktop aesthetics:
 *   sm (<640)   — compact phones (iPhone SE class)
 *   md (<768)   — standard phones + small tablets portrait
 *   lg (<1024)  — tablets landscape + narrow laptops
 *   xl (≥1280)  — full desktop + wide monitors
 *
 * Width alone does not decide desktop app chrome. `useBreakpoint()` only
 * enters desktop mode for large web sessions that do not identify as
 * mobile/tablet clients, so Android/iPad tablets that cross 1024px in
 * landscape still keep touch-first layouts while touch-screen PCs get the
 * desktop shell.
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const

export type BreakpointKey = keyof typeof BREAKPOINTS
